module.exports = __webpack_public_path__ + "img/e2v.937e573d.jpg";